import React from "react";
import { Box } from "theme-ui";
import Search from "./Search";

class Expectations extends React.PureComponent {
  render() {
    return (
      <Box>
        <Search version={this.props.version}/>
      </Box>
    );
  }
}

export default Expectations;
